require('./../vendor/_jquery.js');
const URI = require('./../../vendor/node_modules/urijs');
window.URI = URI;
